import React from 'react';
import Styles from './module-certificate-approved-styles.scss';
import classNames from 'classnames';
import { CongratzCertificateIcon } from '@/presentation/components/icons';
import { ButtonKVBase } from '@/presentation/components';
import DownloadFileCertificate from '@/presentation/components/icons/download-fiile-certificate';
import { renderMascot } from '@/presentation/utils/functions';
const ModuleCertificateApproved = ({ grade, onOpenCertificate, onClick, isDownloading }) => {
    return (React.createElement("div", { className: classNames([Styles.moduleItemWrap]) },
        React.createElement("div", { className: Styles.content },
            React.createElement(CongratzCertificateIcon, null),
            React.createElement("div", { className: Styles.title }, "Congratulations!"),
            React.createElement("div", { className: Styles.subTitle }, "Certificate of Completion"),
            React.createElement("div", { className: Styles.paragraph }, `You have leveled up! You have passed ${grade} Grade Finance.`),
            React.createElement("div", { className: Styles.buttons },
                React.createElement(ButtonKVBase, { onClick: () => onClick(), type: "button", leftIcon: React.createElement(DownloadFileCertificate, { color: "white" }), btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", loading: isDownloading }, "Download"),
                React.createElement("button", { type: "button", className: Styles.certificateButton, onClick: () => onOpenCertificate() }, "VIew Certificate"))),
        React.createElement("div", { className: Styles.icon },
            React.createElement("div", null, renderMascot(100, '300px', '260px')))));
};
export default ModuleCertificateApproved;
